import { lazy } from "react";

export const WorkspaceActivityView = lazy(
  () => import("./WorkspaceActivityView"),
);
